import React from "react";
import "../css/conicComSpotlight.css";

const ConicComSpotlight: React.FC = () => {
  return <div className="scl--conic-com-spotlight" />;
};

export default ConicComSpotlight;